import { render, staticRenderFns } from "./cusPagination.vue?vue&type=template&id=c6f55496&functional=true"
import script from "./cusPagination.vue?vue&type=script&lang=js"
export * from "./cusPagination.vue?vue&type=script&lang=js"
import style0 from "./cusPagination.vue?vue&type=style&index=0&id=c6f55496&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports